const getters = {
  employeeFilter: (state) => {
    let result = "";
    if (state.eventEmployeesFilters.role) {
      result += `role=${state.eventEmployeesFilters.role}&`;
    }
    if (state.eventEmployeesFilters.organizationID) {
      result += `organization_id=${state.eventEmployeesFilters.organizationID}&`;
    }
    if (state.eventEmployeesFilters.fndID) {
      result += `fnd_id=${state.eventEmployeesFilters.fndID}&`;
    }
    return result;
  }
};

export default getters;
